export enum LOCAL_STORAGE_NAMES {
  MEDIA_CONSTRAINTS = "mediaConstraints",
}
export const DEFAULT_LOCALE = "en-US";
